import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const ButtonsBlock = styled(Grid)({
  width: "220px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  margin: "5px 0",

  "& > .MuiButton-root": {
    textTransform: "none",
    fontSize: "12px",
    width: "100px",
    height: "40px",
  },
});
